// import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const alertResource = '/superadmin/tenants/banner_alerts/details'

export default {
  getBannerAlerts() {
    return OperationsRepository.get(`${alertResource}`)
  },
}
